import { CactiIcon } from "../../../icons";

export const EmptyStateSection = ({ searchQuery, sectionTitle, tab }: { searchQuery?: string; sectionTitle: string; tab?: string; }) => (
  <div className="empty-state">
    <div className="empty-state__icon">
      <CactiIcon />
    </div>
    <p className="empty-state__title">
      {searchQuery ? (
        <>
          No results found in<br />
          {sectionTitle}{tab?.length ? ` ${tab}s` : ""}
        </>
      ) : `No ${sectionTitle} assets yet`}
    </p>

    {searchQuery ? (
      <>
        <p className="empty-state__description">
          Try adjusting your search
        </p>

        <a
          className="empty-state__link"
          role="button"
          aria-label="Search all assets"
          href='/'
        >
          Search all assets
        </a>
      </>
    ) : (
      <p className="empty-state__description">
        Drop files here or upload from computer
      </p>
    )}
  </div>
)